import { Reducer } from 'redux';
import { PolymerState, PolymersTypes } from '../../types/polymers.types';

const INITIAL_STATE: PolymerState = {
    items: [],
    loading: false,
    error: false,
    message: ''
};

const reducer: Reducer<PolymerState> = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PolymersTypes.FILTER_REQUEST:
            return { ...state, loading: true };
        case PolymersTypes.FILTER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                items: action.payload.polymers,
                message: action.payload.message
            };
        case PolymersTypes.FILTER_FAILURE:
            return {
                ...state,
                loading: false,
                error: true,
                items: [],
                message: ''
            };
        default:
            return state;
    }
};

export default reducer;
